import {ZadSaleListPaymentSummary} from '../../../models/zad'
import {buildZadListQuery} from '../zad/query'
import {FetchZadSalesRequest} from './types'

/**
 * Sales list query. Sale-date mode keeps the legacy startDate/endDate (saleDate) filter;
 * payment-date mode sends dateMode=PAYMENT with Africa/Tunis calendar days and never
 * startDate/endDate, so the two date filters cannot silently combine.
 */
export function buildZadSaleListQuery(payload: FetchZadSalesRequest): string {
  const payment = payload.dateMode === 'PAYMENT'
  const query = new URLSearchParams(
    buildZadListQuery({
      ...payload,
      startDate: payment ? '' : payload.startDate,
      endDate: payment ? '' : payload.endDate,
    })
  )
  if (!payment) return query.toString()
  query.set('dateMode', 'PAYMENT')
  const from = String(payload.paymentDateFrom || '').trim()
  const to = String(payload.paymentDateTo || '').trim()
  if (from) query.set('paymentDateFrom', from)
  if (to) query.set('paymentDateTo', to)
  return query.toString()
}

const finite = (value: unknown) => {
  const n = Number(value)
  return Number.isFinite(n) ? n : 0
}

const ymdOrNull = (value: unknown) =>
  typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) ? value : null

export function readZadSalePaymentSummary(raw: unknown): ZadSaleListPaymentSummary | null {
  if (!raw || typeof raw !== 'object') return null
  const obj = raw as Record<string, unknown>
  return {
    paymentDateFrom: ymdOrNull(obj.paymentDateFrom),
    paymentDateTo: ymdOrNull(obj.paymentDateTo),
    totalCollected: finite(obj.totalCollected),
    paymentCount: finite(obj.paymentCount),
    saleCount: finite(obj.saleCount),
  }
}
